'use client';

import { Typography } from '@/components/ui/Text';
import { muxPosterUrl, muxVideoUrl } from '@/lib/directus/muxAssetUrl';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { TBlogModuleVideo } from '../../blog/blog.types';

import './BlogArticleModuleVideo.scss';

const VideoPlayer = dynamic(() => import('next-video/player'), { ssr: false });

type Props = {
  module: TBlogModuleVideo;
  mobile?: boolean;
};

export const BlogArticleModuleVideo: React.FC<Props> = ({
  module,
  mobile = false,
}) => {
  const videoContent = muxVideoUrl(module.videoId);
  const videoPoster = muxPosterUrl(
    module.videoId,
    module.thumbnailTimestamp || 0
  );

  return (
    <div
      className={clsx('BlogArticleModuleVideo', {
        'BlogArticleModuleVideo--desktop': !mobile,
        'BlogArticleModuleVideo--mobile': mobile,
      })}
    >
      {module.title && <Typography variant='h3'>{module.title}</Typography>}

      <div
        className={clsx({
          'BlogArticleModuleVideo__video-wrapper--rounded': module.rounded,
        })}
      >
        <VideoPlayer src={videoContent} poster={videoPoster} />
      </div>
    </div>
  );
};
